module.exports = __webpack_public_path__ + "static/media/14.f7214076.png";